

















































































import { Component, Mixins } from 'vue-property-decorator';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import QrCode from 'qrcode.vue';
import copy from 'copy-to-clipboard';

@Component({
    components: {
        QrCode,
    },
})
export default class NemCardWallet extends Mixins(IsMobileMixin) {
    public copyToClibboardSnackBar = false;

    public walletEvent(action: string, label: any) {
        this.$ga.event('Wallet', 'click', action, label);
    }

    public initCopy(text: any) {
        this.walletEvent('Copy Address', 'copy icon');
        copy(text);
        this.copyToClibboardSnackBar = true;
    }

    get size() {
        if (this.isMobile) {
            return 88;
        }
        return 110;
    }

    get balance() {
        return this.$store.getters.getBalance;
    }

    get address() {
        return this.$store.getters.getAddress;
    }

    get qrCode() {
        return JSON.stringify({
            v: 2,
            type: 2,
            data: {
                addr: this.address,
                amount: 0,
            },
        });
    }
}
